var path = 'ui-formly/types/textarea/index.html';
var html = "<textarea class=\"form-control\" ng-model=\"model[options.key]\"></textarea>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;